"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateActions = void 0;
var UpdateActions;
(function (UpdateActions) {
    UpdateActions["IntermittentSaveEnrichmentForm"] = "save_questionnaire_data";
    UpdateActions["SubmitEnrichmentForm"] = "submit_questionnaire_data";
    UpdateActions["SubmitQuotation"] = "submit_quotation_data";
    UpdateActions["SaveQuotation"] = "save_quotation_data";
    UpdateActions["SaveQuotationApproval"] = "save_quotation_approval_data";
    UpdateActions["SubmitQuotationApproval"] = "submit_quotation_approval_data";
    UpdateActions["SubmitQuotationRejected"] = "submit_quotation_rejected_data";
    UpdateActions["SaveCooldownData"] = "save_cooldown_data";
    UpdateActions["SaveInstallationData"] = "save_installation_data";
    UpdateActions["SubmitInstallationData"] = "submit_installation_data";
    UpdateActions["SaveFulfilmentData"] = "save_fulfilment_data";
    UpdateActions["SubmitRejectReview"] = "submit_quotation_to_datacollection";
    UpdateActions["SaveReimbursementData"] = "save_reimbursement_data";
    UpdateActions["SubmitReimbursementData"] = "submit_reimbursement_data";
    UpdateActions["SaveReimbursementFulfilmentData"] = "save_reimbursement_fulfilment";
    UpdateActions["SubmitReimbursementFulfilmentData"] = "submit_reimbursement_fulfilment";
    UpdateActions["SaveLeaseApproval"] = "save_lease_approval";
    UpdateActions["SaveDriverApproval"] = "save_driver_approval";
    UpdateActions["UploadLeaseQuotation"] = "submit_lease_quotation";
    UpdateActions["ApproveLeaseQuotation"] = "submit_lease_approval";
    UpdateActions["RejectLeaseQuotation"] = "quotation_rejected_by_lease";
    UpdateActions["UploadDriverQuotation"] = "submit_driver_quotation";
    UpdateActions["ApproveDriverQuotation"] = "submit_driver_approval";
    UpdateActions["RejectDriverQuotation"] = "quotation_rejected_by_driver";
    UpdateActions["SaveDriverQuotation"] = "save_driver_quotation";
})(UpdateActions || (exports.UpdateActions = UpdateActions = {}));
